import { ReactElement } from 'react';
import LikelyPossibilities from '@components/FVSPage/LikelyPossibilities';
import { fvsInfoDisplayObject } from '@services/FormFieldConfig';

function FVSStep19(): ReactElement {
  return (
    <>
      <LikelyPossibilities displayObject={fvsInfoDisplayObject} currentStepNo="step19" />
    </>
  );
}

export default FVSStep19;
